import { render, staticRenderFns } from "./GoodsShoot.vue?vue&type=template&id=5c652a2a&scoped=true&"
import script from "./GoodsShoot.vue?vue&type=script&lang=js&"
export * from "./GoodsShoot.vue?vue&type=script&lang=js&"
import style0 from "./GoodsShoot.vue?vue&type=style&index=0&id=5c652a2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c652a2a",
  null
  
)

export default component.exports